/* global jQuery */

var $ = jQuery,
    App = {
        debug: true,
        wcag_state: {
            init: function () {
                var json = sessionStorage.getItem('wcag_state');

                if (json && json.length) {
                    var data = JSON.parse(json);
                    if (data instanceof Object) {
                        this.data.color = data.color;
                        this.data.text_size = data.text_size;
                        this.data.animation = data.animation;
                        this.data.plain_text = data.plain_text;

                        $('html').addClass(this.data.color + ' ' + this.data.text_size + ' ' + this.data.animation + ' ' + this.data.plain_text);
                    }
                }
            },
            set: function (name, value) {
                this.data[name] = value;
                console.log(this.data);
                this.save();
            },
            reset: function () {
                this.data.color = '';
                this.data.text_size = '';
                this.data.animation = '';
                this.data.plain_text = '';

                this.save();
            },
            save: function () {
                var json = JSON.stringify(this.data);

                sessionStorage.setItem('wcag_state', json);
            },
            data: {
                color: '',
                text_size: '',
                animation: '',
                plain_text: ''
            }
        },
        init: function () {
            this.wcag_state.init();
            this.scripts();
            this.sliders();
            this.mobMenu($('.page-header'));
            this.translate_language();
            this.search_form();
        },
        loaded: function () {},

        scripts: function () {
            var $win = $(window),
                $html = $('html'),
                $body = $('body', $html),
                scrollPos = $win.scrollTop(),
                didScroll,
                lastScrollTop = 0,
                delta = 0,
                headerHeight = $('.page-header').outerHeight(),
                $transcriptBtn = $('.transcript-trigger'),
                $transcriptText = $('.video-transcript');

            function simpleParallax(intensity, element) {
                $win.scroll(function () {
                    var scrollTop = $(window).scrollTop();
                    var elPos = scrollTop / intensity + 'px';
                    element.css('transform', 'translateY(' + elPos + ')');
                });
            }

            var parallaxEl = $('.bg-wrapper .parallax');

            simpleParallax(1.5, parallaxEl);

            // Tooltips / Popovers
            var tooltipEl = $('[data-bs-toggle="popover"]');

            tooltipEl.each(function (i, elm) {
                var $elm = $(elm);

                $elm.popover({
                    trigger: 'manual',
                    content: function () {
                        var $this = $(this);

                        if ($this.data('target') !== undefined && $this.data('target').length && $($this.data('target')).length) {
                            return $($this.data('target')).html();
                        } else {
                            return $this.data('bs-content');
                        }
                    }
                }).on(App.is_touch() ? 'click' : 'mouseenter', function (event) {
                    event.stopPropagation();

                    console.log('Click / mouseenter');
                    tooltipEl.popover('hide');
                    $elm.popover('show');

                    // $elm.siblings(".popover").on("mouseleave", function() {
                    //     $elm.popover('hide');
                    // });
                });
                if (!App.is_touch()) {
                    $elm.on('mouseleave', function () {
                        setTimeout(function () {
                            if (!$('.popover:hover').length) {
                                $elm.popover('hide');
                            }
                        }, 100);
                    });
                }
            });
            // Fallbacks
            $body.on('click', function () {
                tooltipEl.popover('hide');
            });
            if (!App.is_touch()) {
                $body.on('inserted.bs.popover', function () {
                    $('.popover.bs-popover-auto')
                        .one('mouseleave', function () {
                            tooltipEl.popover('hide');
                        })
                        .on('click dblclick', function (event) {
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                            // event.preventDefault();
                        });
                });
            }

            // Transcript
            $transcriptBtn.on('click', function (e) {
                e.preventDefault();
                $(this).parent().parent().next($transcriptText).slideToggle(350);
            });

            var $pageHeader = $('.page-header'),
                $dataDesktopHeader = $('[data-desktop-header]'),
                $dataMobileHeader = $('[data-mobile-header]'),
                $searchTrigger = $('.search-trigger'),
                $searchClose = $('.search-close'),
                $wcagBlock = $('.accessibility-options-wrapper'),
                $wcagTrigger = $('.accessibility-trigger'),
                $wcagClose = $('.accessibility-close', $wcagBlock),
                $wcagBlackWhite = $('.white-on-black-btn', $wcagBlock),
                $wcagContrast = $('.black-on-white-btn', $wcagBlock),
                $wcagTextUp = $('.increase-text-btn', $wcagBlock),
                $wcagTextDown = $('.decrease-text-btn', $wcagBlock),
                $wcagNoAnim = $('.no-animations-btn', $wcagBlock),
                $wcagPlainText = $('.plain-text-btn', $wcagBlock),
                $wcagReset = $('.reset-btn', $wcagBlock),
                $uberItem = $('.ubermenu-main .ubermenu-item-level-0 > a', $pageHeader);


            function setHeaderHeight() {
                const desktopHeight = $dataDesktopHeader.length ? $dataDesktopHeader.outerHeight() : 0;
                const mobileHeight = $dataMobileHeader.length ? $dataMobileHeader.outerHeight() : 0;
                const height = desktopHeight > 0 ? desktopHeight : mobileHeight;
                const root = document.querySelector(':root');
                root.style.setProperty('--header-height', height + 'px');
            }
            $win.scroll(function (event) {
                didScroll = true;
                setHeaderHeight();
            });
            $win.resize(function (event) {
                setHeaderHeight();
            });
            setHeaderHeight();
            if ($win.scrollTop() >= 1) {
                $body.addClass('page-scrolled');
            } else {
                $body.removeClass('page-scrolled');
            }

            function hasScrolled() {
                var st = $(this).scrollTop();

                if (Math.abs(lastScrollTop - st) <= delta) return;

                if (st > 1) {
                    $body.addClass('page-scrolled');
                } else {
                    $body.removeClass('page-scrolled');
                }

                lastScrollTop = st;
            }

            setInterval(function () {
                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }
            }, 15);

            $uberItem.click(function (e) {
                // console.log('uber klikk');
                // e.preventDefault();
            });

            $searchTrigger.click(function (e) {
                e.preventDefault();
                $pageHeader.addClass('search-opened');
                $(this).parent().addClass('search-opened');
                $(this).parent().find('form input[type=text]').focus();
            });

            $searchClose.click(function (e) {
                e.preventDefault();
                $pageHeader.removeClass('search-opened');
                $(this).parent().parent().removeClass('search-opened');
            });

            $wcagTrigger.click(function (e) {
                e.preventDefault();
                const wcagHeight = $wcagBlock.outerHeight();
                document.documentElement.style.setProperty('--wcag-height', wcagHeight + 'px');

                if ($pageHeader.hasClass('wcag-opened')) {
                    $body.css('margin-top', 0);
                } else {
                    $body.css('margin-top', wcagHeight);
                }
                $pageHeader.toggleClass('wcag-opened');
                $(this).parent().toggleClass('wcag-opened');
            });

            $wcagClose.click(function (e) {
                e.preventDefault();
                $body.css('margin-top', 0);
                document.documentElement.style.setProperty('--wcag-height', '0px');
                $pageHeader.removeClass('wcag-opened');
                $(this).parent().parent().removeClass('wcag-opened');
            });

            // WCAG styles

            $wcagBlackWhite.click(function (e) {
                e.preventDefault();

                $html.removeClass('contrast-styles white-on-black-styles');

                if ($wcagBlackWhite.hasClass('active')) {
                    $wcagBlackWhite.removeClass('active');
                    App.wcag_state.set('color', '');
                } else {
                    $wcagContrast.removeClass('active');
                    $wcagBlackWhite.addClass('active');
                    $html.addClass('white-on-black-styles');
                    App.wcag_state.set('color', 'white-on-black-styles');
                }
            });

            $wcagContrast.click(function (e) {
                e.preventDefault();

                $html.removeClass('contrast-styles white-on-black-styles');

                if ($wcagContrast.hasClass('active')) {
                    $wcagContrast.removeClass('active');
                    App.wcag_state.set('color', '');
                } else {
                    $wcagBlackWhite.removeClass('active');
                    $wcagContrast.addClass('active');
                    $html.addClass('contrast-styles');
                    App.wcag_state.set('color', 'contrast-styles');
                }
            });

            if (App.wcag_state.data.color) {
                if (App.wcag_state.data.color == 'white-on-black-styles') {
                    $wcagBlackWhite.addClass('active');
                }
                if (App.wcag_state.data.color == 'contrast-styles') {
                    $wcagContrast.addClass('active');
                }
            }

            $wcagTextUp.click(function (e) {
                e.preventDefault();

                if ($html.hasClass('text-size-xxl-styles')) {
                    return;
                } else if ($html.hasClass('text-size-xs-styles')) {
                    $html.removeClass('text-size-xs-styles');
                    $html.addClass('text-size-s-styles');

                    App.wcag_state.set('text_size', 'text-size-s-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else if ($html.hasClass('text-size-s-styles')) {
                    $html.removeClass('text-size-s-styles');
                    $html.addClass('text-size-m-styles');

                    App.wcag_state.set('text_size', 'text-size-m-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else if ($html.hasClass('text-size-l-styles')) {
                    $html.removeClass('text-size-l-styles');
                    $html.addClass('text-size-xl-styles');

                    App.wcag_state.set('text_size', 'text-size-xl-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else if ($html.hasClass('text-size-xl-styles')) {
                    $html.removeClass('text-size-xl-styles');
                    $html.addClass('text-size-xxl-styles');

                    App.wcag_state.set('text_size', 'text-size-xxl-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else {
                    $html.removeClass('text-size-m-styles');
                    $html.addClass('text-size-l-styles');

                    App.wcag_state.set('text_size', 'text-size-l-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                }
            });

            $wcagTextDown.click(function (e) {
                e.preventDefault();

                if ($html.hasClass('text-size-xs-styles')) {
                    return;
                } else if ($html.hasClass('text-size-xxl-styles')) {
                    $html.removeClass('text-size-xxl-styles');
                    $html.addClass('text-size-xl-styles');

                    App.wcag_state.set('text_size', 'text-size-xl-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else if ($html.hasClass('text-size-xl-styles')) {
                    $html.removeClass('text-size-xl-styles');
                    $html.addClass('text-size-l-styles');

                    App.wcag_state.set('text_size', 'text-size-l-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else if ($html.hasClass('text-size-l-styles')) {
                    $html.removeClass('text-size-l-styles');
                    $html.addClass('text-size-m-styles');

                    App.wcag_state.set('text_size', 'text-size-m-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else if ($html.hasClass('text-size-s-styles')) {
                    $html.removeClass('text-size-s-styles');
                    $html.addClass('text-size-xs-styles');

                    App.wcag_state.set('text_size', 'text-size-xs-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                } else {
                    $html.removeClass('text-size-m-styles');
                    $html.addClass('text-size-s-styles');

                    App.wcag_state.set('text_size', 'text-size-s-styles');

                    setTimeout(function () {
                        $body.css('margin-top', $wcagBlock.outerHeight());
                    }, 400);
                }
            });

            $wcagNoAnim.click(function (e) {
                e.preventDefault();
                $(this).toggleClass('active');

                if ($html.hasClass('no-anim-styles')) {
                    $html.removeClass('no-anim-styles');
                    App.wcag_state.set('animation', '');
                } else {
                    $html.addClass('no-anim-styles');
                    App.wcag_state.set('animation', 'no-anim-styles');
                }
            });
            if (App.wcag_state.data.animation) {
                $wcagNoAnim.addClass('active');
            }

            $wcagPlainText.click(function (e) {
                e.preventDefault();
                $(this).toggleClass('active');

                if ($html.hasClass('plain-text-styles')) {
                    $html.removeClass('plain-text-styles');
                    App.wcag_state.set('plain_text', '');
                } else {
                    $html.addClass('plain-text-styles');
                    App.wcag_state.set('plain_text', 'plain-text-styles');
                }

                setTimeout(function () {
                    $body.css('margin-top', $wcagBlock.outerHeight());
                }, 400);
            });
            if (App.wcag_state.data.plain_text) {
                $wcagPlainText.addClass('active');
            }

            $wcagReset.click(function (e) {
                e.preventDefault();
                $('html, body').removeClass('white-on-black-styles contrast-styles no-anim-styles plain-text-styles text-size-xs-styles text-size-s-styles text-size-l-styles text-size-xl-styles text-size-xxl-styles');
                $('.btn', $wcagBlock).removeClass('active');

                App.wcag_state.reset();
                setTimeout(function () {
                    $body.css('margin-top', $wcagBlock.outerHeight());
                }, 400);
            });

            var $resourceFilterSection = $('.resource-search-section'),
                $resourceFilterTrigger = $('.resource-filter-trigger', $resourceFilterSection),
                $resourceFilterClose = $('.filter-close', $resourceFilterSection),
                $projectFilterSection = $('.project-search-section'),
                $projectFilterTrigger = $('.project-filter-trigger', $projectFilterSection),
                $projectFilterClose = $('.filter-close', $projectFilterSection),
                $mapFilterSection = $('.resource-map-filter-section'),
                $mapFilterTrigger = $('.resource-map-filter-trigger-btn', $mapFilterSection),
                $filterClose = $('.filter-close', $mapFilterSection);

            $resourceFilterTrigger.click(function (e) {
                e.preventDefault();
                $body.addClass('resource-filter-opened');
            });

            $resourceFilterClose.click(function (e) {
                e.preventDefault();
                $body.removeClass('resource-filter-opened');
            });

            $projectFilterTrigger.click(function (e) {
                e.preventDefault();
                $body.addClass('project-filter-opened');
            });

            $projectFilterClose.click(function (e) {
                e.preventDefault();
                $body.removeClass('project-filter-opened');
            });

            $mapFilterTrigger.click(function (e) {
                e.preventDefault();
                $body.addClass('map-filter-opened');
            });

            $filterClose.click(function (e) {
                e.preventDefault();
                $body.removeClass('map-filter-opened');
            });

            // To top
            $('.back-top').on('click', function () {
                $('html,body').animate(
                    {
                        scrollTop: 0
                    },
                    550
                );
            });

            // Content link
            $('.content-link').click(function (e) {
                if ($(this).attr('data-slug').length && typeof $(this).data('slug') !== 'undefined') {
                    e.preventDefault();
                    var id = $(this).attr('data-slug');
                    $('html,body').animate(
                        {
                            scrollTop: $('#' + id).offset().top - 50
                        },
                        550
                    );
                }
            });

            // Copy buttons
            var copy_buttons = $('.btn.copy-btn');

            if (copy_buttons.length) {
                copy_buttons.on('click', function (event) {
                    event.preventDefault();

                    App.copy_to_clipboard($(this).attr('href'));
                });
            }

            (function () {
                const accordionButtons = document.querySelectorAll('[data-accordion-button]');
                accordionButtons.forEach(button => {
                    const targetId = button.getAttribute('data-bs-target');
                    const collapseElement = document.querySelector(targetId);
                    const link = button.previousElementSibling; 

                    collapseElement.addEventListener('show.bs.collapse', () => {
                        link.classList.add('active'); 
                    });
                
                    collapseElement.addEventListener('hide.bs.collapse', () => {
                        link.classList.remove('active')
                    });
                });
              }());
              
              
        },
        sliders: function () {
            var carousel_slider = $('.carousel-slider .swiper-container');

            if (carousel_slider.length) {
                carousel_slider.each(function () {
                    var $this = $(this),
                        slides_count = 1,
                        centered_slider = true;

                    $this.data(
                        'swiper',
                        new Swiper($this, {
                            loop: false,
                            effect: 'slide',
                            centeredSlides: centered_slider,
                            slidesPerView: 1,
                            spaceBetween: 0,
                            speed: 700,
                            grabCursor: false,
                            //autoplay: 6000,
                            navigation: {
                                nextEl: $this.parent().find('.swiper-button-next')[0],
                                prevEl: $this.parent().find('.swiper-button-prev')[0]
                            },
                            breakpoints: {
                                480: {
                                    slidesPerView: 1
                                },
                                // when window width is >= 640px
                                640: {
                                    slidesPerView: slides_count
                                }
                            }
                        })
                    );
                });
            }

            var posts_slider = $('.posts-slider .swiper-container');

            if (posts_slider.length) {
                posts_slider.each(function () {
                    var $this = $(this),
                        slides_count = 3,
                        centered_slider = false;

                    $this.data(
                        'swiper',
                        new Swiper($this, {
                            loop: false,
                            effect: 'slide',
                            centeredSlides: centered_slider,
                            slidesPerView: 1.1,
                            spaceBetween: 0,
                            speed: 700,
                            grabCursor: false,
                            //autoplay: 6000,
                            navigation: {
                                nextEl: $this.parent().find('.swiper-button-next')[0],
                                prevEl: $this.parent().find('.swiper-button-prev')[0]
                            },
                            breakpoints: {
                                576: {
                                    slidesPerView: 2,
                                },
                                // when window width is >= 640px
                                768: {
                                    slidesPerView: slides_count
                                }
                            }
                        })
                    );
                });
            }
        },

        mobMenu: function (menuWrapper) {
            var $this = menuWrapper,
                $win = $(window);
                $html = $('html');
                $body = $('body');

            /* toggle main menu nav */
            $('.menu-btn', $this).on('click', function () {
                menuWrapper.toggleClass('menu-opened');
                $body.toggleClass('menu-opened');
                $html.toggleClass('menu-opened');
                if (($body.hasClass('page-bg-lightblue') || $body.hasClass('single-resource') || $body.hasClass('single-post')) && !($win.scrollTop())) {
                    $body.toggleClass('page-scrolled');
                }
            });

            $(window).on('keyup', function (event) {
                if ($body.hasClass('menu-opened')) {
                    switch (event.keyCode) {
                        case 27: //esc
                            menuWrapper.removeClass('menu-opened');
                            $body.removeClass('menu-opened');
                            $html.removeClass('menu-opened');
                            break;
                    }
                }
            });

            // $.fn.doubleTapToGo = function(params) {
            //     if (!('ontouchstart' in window) &&
            //         !navigator.msMaxTouchPoints &&
            //         !navigator.userAgent.toLowerCase().match(/windows phone os 7/i)) return false;

            //     this.each(function() {
            //         var curItem = false;

            //         $(this).on('click', function(e) {
            //             var item = $(this);
            //             if (item[0] != curItem[0]) {
            //                 e.preventDefault();
            //                 curItem = item;
            //             }
            //         });

            //         $(document).on('click touchstart MSPointerDown', function(e) {
            //             var resetItem = true,
            //                 parents = $(e.target).parents();

            //             for (var i = 0; i < parents.length; i++)
            //                 if (parents[i] == curItem[0])
            //                     resetItem = false;

            //             if (resetItem)
            //                 curItem = false;
            //         });
            //     });
            //     return this;
            // };

            //$('.mobile-nav-wrapper #menu-primary>li:has(ul)', menuWrapper).doubleTapToGo();
        },

        copy_to_clipboard: function (element) {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(element).select();
            document.execCommand('copy');
            $temp.remove();
        },

        translate_language: function () {
            var language = sessionStorage.getItem('translate_language');
            var gbtn = $('.btn-gtranslate');
            var url = gbtn.attr('href');

            console.log(language, typeof language);

            if (typeof language == 'undefined' || language == null || language == '') {
                let request = {
                    action: 'api',
                    method: 'check-language'
                };

                $.get(ajax_url, request, function (response) {
                    language = response.data;
                    sessionStorage.setItem('translate_language', response.data);
                    gbtn.attr('href', url + response.data);
                });
            }

            gbtn.attr('href', url + language);
        },
        search_form: function () {
            var search_form = $('.mini-search-form');

            search_form.each(function () {
                var $this = $(this),
                    input = $('.search-input', $this),
                    results = $('.mini-results', $this);

                input.on('keyup', function () {
                    if (input.val().length >= 2) {
                        let request = {
                            action: 'api',
                            method: 'search-results',
                            search: input.val()
                        };

                        $.get(ajax_url, request, function (response) {
                            if (response.success) {
                                results.html(response.data);
                            }
                        });
                    }
                });
            });
        },
        is_touch: function () {
            return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        }
    };

jQuery(document).ready(function () {
    App.init();
});

// Back to Top functionality
window.addEventListener('scroll', function() {
    const button = document.getElementById('back-to-top');
    if(button) {
        if (window.scrollY > 100) {
            button.style.display = 'block';
        } else {
            button.style.display = 'none';
        }
    }
});

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}


jQuery(window).on('load', function () {
    App.loaded();
});



document.addEventListener("DOMContentLoaded", () => {
    const projectFilterWrapper = document.querySelector(".project-filter-wrapper");
    if (projectFilterWrapper) {
        const projectFilterButtons = projectFilterWrapper.querySelectorAll(".project-filter-buttons");
        projectFilterButtons.forEach(projectFilterButton => {
            
            const fieldHeader = projectFilterButton.querySelector(".field-header label");
            const checkboxes = projectFilterButton.querySelectorAll(".checkbox-container input[type='checkbox']");
    
            if (fieldHeader && checkboxes) {
    
                const updateCheckedCount = () => {
                    const checkedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
                    let countSpan = fieldHeader.querySelector("span");
                    if (!countSpan && checkedCount > 0) {
                        countSpan = document.createElement("span");
                        countSpan.classList.add("checked-count");
                        fieldHeader.appendChild(countSpan);
                    }

                    if (countSpan) {
                        if (checkedCount === 0) {
                            fieldHeader.removeChild(countSpan);
                        } else {
                            countSpan.textContent = checkedCount;
                        }
                    }
                };
                checkboxes.forEach(checkbox => {
                    checkbox.addEventListener("change", () => {
                        updateCheckedCount();
                    });
                });
                updateCheckedCount();
            }
        });
    }


    const flipCards = document.querySelectorAll("[data-flip-card]");
    if (flipCards) {
        flipCards.forEach(card => {
            const frontBtn = card.querySelector('[data-flip-btn="front"]');
            const backBtn = card.querySelector('[data-flip-btn="back"]');
            const backLink = card.querySelector("[data-flip-btn-link]");
            if (frontBtn && backBtn && backLink) { 
                card.querySelectorAll("[data-flip-btn]").forEach(btn => {
                    btn.addEventListener("click", () => {
                        const isFlipped = card.classList.toggle("flipped");
                        frontBtn?.setAttribute("tabindex", isFlipped ? "-1" : "0");
                        backBtn?.setAttribute("tabindex", isFlipped ? "0" : "-1");
                        backLink?.setAttribute("tabindex", isFlipped ? "0" : "-1");
                    });
                });
          
            }
        });
    }

    const innerWrap = document.querySelector('[data-intro-inner-wrap]');
    const introSection = document.querySelector('.section.intro-section');

    if (innerWrap && introSection) {

        let triggerPoint = 0;
        let isScrolledDown = null;

        function calculateTriggerPoint() {
            if (!introSection) return;

            const top = introSection.offsetTop;
            const height = introSection.offsetHeight;
            const marginBottom = parseFloat(
                getComputedStyle(introSection).marginBottom
            ) || 0;

            triggerPoint = top + height - marginBottom;
        }

        function handleScroll() {
            const shouldBeScrolledDown = window.scrollY > triggerPoint;

            if (shouldBeScrolledDown === isScrolledDown) {
                return;
            }

            isScrolledDown = shouldBeScrolledDown;

            if (isScrolledDown) {
                const introPlaceholderHeight = introSection.offsetHeight || 0;

                document.documentElement.style.setProperty(
                    '--sticked-header-height',
                    `${introPlaceholderHeight}px`
                );

                innerWrap?.classList.add('scrolled-down');
                document.body.classList.add('sticked-header');

            } else {
                innerWrap?.classList.remove('scrolled-down');
                document.body.classList.remove('sticked-header');
                calculateTriggerPoint();
            }
        }

        window.addEventListener('load', () => {
            calculateTriggerPoint();
            handleScroll();
        });

        window.addEventListener('resize', () => {
            calculateTriggerPoint();
            handleScroll();
        });

        window.addEventListener('scroll', handleScroll);
    }




    const authors = document.querySelectorAll(
        ".term-participation-in-democratic-life .authors-section .author, .term-participation-in-erasmus-and-european-solidarity-corps .authors-section .author"
    );

    authors.forEach(author => {
        const paragraph = author.querySelector(".author-desc p");
        const arrow = author.querySelector(".arrow");

        if (!paragraph || !arrow) return;

        const lineHeight = parseFloat(getComputedStyle(paragraph).lineHeight);
        const divHeight = paragraph.offsetHeight;
        const lines = divHeight / lineHeight;

        if (lines > 1) {
            paragraph.classList.add('collapsed');

            arrow.addEventListener('click', () => {
                const expanded = paragraph.classList.toggle('collapsed') === false;
                arrow.setAttribute('aria-expanded', expanded);
            });
        } else {
            arrow.style.display = "none";
        }
    });

    var $slider = $('.js-text-list-slider');
    var $block  = $slider.closest('.text-list-slider');

});

jQuery(function ($) {
    $('.js-text-list-slider').each(function () {
        var $slider = $(this);
        var $block  = $slider.closest('.text-list-slider');

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            adaptiveHeight: true,
            dots: false,
            swipeToSlide: true,
            accessibility: true,
            prevArrow: $block.find('.text-list-slider__arrow--prev'),
            nextArrow: $block.find('.text-list-slider__arrow--next')
        });
    });
});
